export const productTypeOptions = [
  {
    label: 'Produto',
    value: 'product',
  },
  {
    label: 'Serviço',
    value: 'service',
  },
]
